import { inject } from '@angular/core';
import { Layout } from '@core/enums/layout';
import { LayoutService } from '@core/services/layout.service';

export const setLayout = (layout: Layout) => {
  return () => {
    inject(LayoutService).setLayout(layout);
  };
};
